import React from 'react';
import { useReferencedComponent } from '@hooks/useReferencedComponent';
import { ArticleBlockContentGridCol } from '../components/ArticleBlockContentGridCol/ArticleBlockContentGridCol';
import { BlockContentContext } from '../../BlockContent.utils';
import {
  ReferencedComponentBlock,
  ReferencedComponentSerializerProps,
} from '../components/ReferencedComponentSerializer/ReferencedComponentSerializer';

export const ReferencedComponentSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  const ArticleBlockContent = ({ value }: ReferencedComponentSerializerProps) => {
    const data = useReferencedComponent(value.documentId);

    if (data?.type === 'bodyFeaturedVehicleTestResult') {
      return <ReferencedComponentBlock value={value} />;
    }

    return (
      <ArticleBlockContentGridCol>
        <ReferencedComponentBlock value={value} />
      </ArticleBlockContentGridCol>
    );
  };

  if (context === BlockContentContext.Article) {
    return ArticleBlockContent;
  }

  return ({ value }: ReferencedComponentSerializerProps) => <ReferencedComponentBlock value={value} />;
};
